import { DropdownQuestionModel } from '../../shared/models/dropdown-question.model';
import { SummerAppFieldTypesEnum } from 'app/shared/enums/field-types.enum';
import { QuestionBaseModel } from '../../shared/models/question-base.model';
import { SelectListItemModel } from '../../shared/models/select-list-item.model';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { SecurityService } from 'app/security/security.service';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';
import { BaseFormValidation } from 'app/shared/validators/base-form-validation';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from './../../shared/app-settings';

@Component({
  selector: 'thankyou-stage',
  templateUrl: './thankyou-stage.component.html',
  styleUrls: ['./thankyou-stage.component.scss']  
})
export class ThankyouComponent {

  constructor(private programsService: EnrollmentProgramsService,
    ) {
  }

  //The documetn requested flag can only be raised when an applicant is invited. Leveraging that condition would allow a 
  //easier way of changing the 
  protected isPaymentMethodConfirmed: boolean = sessionStorage.getItem('isProviderAccess') != null &&  sessionStorage.getItem('isProviderAccess') == 'true';

  // get imageUrl(): Observable<string> {
  //   return Observable.of(`${AppSettings.blobsStorage}/${this.securityService.currentUserInfo.backgroundImgId}`);
  // } 

  public get ThankYouMessage(): Observable<string> {
    return this.programsService.getThankYouMessage();
  }
}



// WEBPACK FOOTER //
// ./src/app/stages/thankyou-stage/thankyou-stage.component.ts